import React from 'react';

const ImageWrapper = ({ Width, MaxWidth, ImgUrl, BorderRadius, showImage }) => {
    return (
        <>
            {showImage ? (
                <a
                    href={ImgUrl}
                    target="__blank"
                    className="image_container"
                    style={{
                        width: `${Width}px`,
                        maxWidth: `${MaxWidth}px`,
                        borderRadius: `${BorderRadius}px`,
                    }}
                >
                    <img className="cover" src={ImgUrl} alt="" />
                </a>
            ) : (
                <div
                    className="image_container"
                    style={{
                        width: `${Width}px`,
                        maxWidth: `${MaxWidth}px`,
                        borderRadius: `${BorderRadius}px`,
                    }}
                >
                    <img className="cover" src={ImgUrl} alt="" />
                </div>
            )}
        </>
    );
};

export default ImageWrapper;
